import React from "react";

import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import SupervisedUserCircleIcon from "@material-ui/icons/SupervisedUserCircle";
import { Link } from "react-router-dom";

import Style from "../../styles/js/Styles.js";
import service from "../../plas/user/service";

export default function UsersMenu( ) {

  const style = Style();
  
  return (
    <div>
      { service.canAdmin() && (
        <ListItem button component={Link} to={"/users"} >
          <ListItemIcon>
            <SupervisedUserCircleIcon />
          </ListItemIcon>
          <ListItemText className={style.menuTextItem} primary="Usuarios" />
        </ListItem>
      )}
    </div>
    
  );
}
